import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDates,
  setEndDate,
  setSelected,
  setStartDate,
} from "../Redux/reportSlice";

const ToggleButtons = ({ setTempStartDate, setTempEndDate }) => {
  const dispatch = useDispatch();

  // Access dates and selected from Redux store
  const { dates, selected } = useSelector((state) => state.report);

  useEffect(() => {
    if (selected === "Day" && (!dates.startDate || !dates.endDate)) {
      const today = new Date().toISOString().split("T")[0];
      dispatch(setDates({ startDate: today, endDate: today }));
    } else if (selected === "Week" && (!dates.startDate || !dates.endDate)) {
      const today = new Date();
      const firstDayOfWeek = new Date(
        today.setDate(today.getDate() - today.getDay() + 1)
      );
      const lastDayOfWeek = new Date(
        today.setDate(firstDayOfWeek.getDate() + 6)
      );
      dispatch(
        setDates({
          startDate: firstDayOfWeek.toISOString().split("T")[0],
          endDate: lastDayOfWeek.toISOString().split("T")[0],
        })
      );
    } else if (selected === "Month" && (!dates.startDate || !dates.endDate)) {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      dispatch(
        setDates({
          startDate: firstDayOfMonth.toISOString().split("T")[0],
          endDate: lastDayOfMonth.toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch, selected, dates]);

  const handleToggle = (value) => {
    dispatch(setSelected(value));
    setTempStartDate(null);
    setTempEndDate(null);
    dispatch(setStartDate(null)); // Apply the start date to Redux store
    dispatch(setEndDate(null));

    const today = new Date();
    if (value === "Day") {
      const todayFormatted = today.toISOString().split("T")[0];
      dispatch(
        setDates({ startDate: todayFormatted, endDate: todayFormatted })
      );
    } else if (value === "Week") {
      const firstDayOfWeek = new Date(
        today.setDate(today.getDate() - today.getDay() + 1)
      );
      const lastDayOfWeek = new Date(
        today.setDate(firstDayOfWeek.getDate() + 6)
      );
      dispatch(
        setDates({
          startDate: firstDayOfWeek.toISOString().split("T")[0],
          endDate: lastDayOfWeek.toISOString().split("T")[0],
        })
      );
    } else if (value === "Month") {
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      dispatch(
        setDates({
          startDate: firstDayOfMonth.toISOString().split("T")[0],
          endDate: lastDayOfMonth.toISOString().split("T")[0],
        })
      );
    }
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent={"space-between"}
        gap={2}
        sx={{
          backgroundColor: "#f4faff",
          padding: "5px",
          borderRadius: "4px",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
          border: "1px solid #C1C1C2",
          width: "215px",
        }}
      >
        {["Day", "Week", "Month"].map((label) => (
          <Button
            key={label}
            variant={selected === label ? "contained" : "outlined"}
            onClick={() => handleToggle(label)}
            size="small"
            sx={{
              fontWeight: "bold",
              border: "none",
              color: selected === label ? "#fff" : "#000",
              backgroundColor: selected === label ? "#0d547e" : "transparent",
              boxShadow:
                selected === label ? "0px 4px 6px rgba(0, 0, 0, 0.2)" : "none",
              "&:hover": {
                backgroundColor: selected === label ? "#0b486e" : "transparent",
                boxShadow:
                  selected === label
                    ? "0px 4px 8px rgba(0, 0, 0, 0.3)"
                    : "none",
                border: "unset",
              },
            }}
          >
            {label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default ToggleButtons;
